import type { Table } from '@tanstack/react-table'
import { useSelector } from 'react-redux'

import { BeneficiaryList } from '@/components/beneficiary/BeneficiaryList'
import { AddFilterWrapper } from '@/components/beneficiary/list/AddFilter'
import { BeneficiaryFilterSearchTextWrapper } from '@/components/beneficiary/list/BeneficiaryFilterSearchText'
import { BeneficiaryListFiltersWrapper } from '@/components/beneficiary/list/BeneficiaryListFilters'
import { BeneficiaryListPagination } from '@/components/beneficiary/list/BeneficiaryListPagination'
import { FilterTemplateManagerWrapper } from '@/components/beneficiary/list/filter-template/FilterTemplateManager'
import { ResetFiltersWrapper } from '@/components/beneficiary/list/ResetFilters'
import { ColumnsSelector } from '@/components/beneficiary/list/table/ColumnsSelector'
import { CsvExporter } from '@/components/beneficiary/list/table/CsvExporter'
import { BeneficiaryListDataItem } from '@/components/beneficiary/list/table/Table'
import { TasksCreator } from '@/components/tasks/TaskCreator'
import { selectBeneficiaries } from '@/store/beneficiary-list-filters/selectors'
import { useStoreState } from '@/store/hooks'

export function BeneficiaryListWithFiltersAndPagination({
  onSelectBeneficiary,
}: {
  onSelectBeneficiary?: () => void
}) {
  return (
    <div className="space-y-2">
      <div className="flex flex-col gap-2">
        <div className="border-primary-50 my-4 flex items-center gap-2 border-b bg-white pb-4 shadow-sm">
          <FilterTemplateManagerWrapper />
        </div>
      </div>
      <div className="inline-flex flex-1 flex-wrap items-center gap-2">
        <BeneficiaryFilterSearchTextWrapper />
        <AddFilterWrapper />
        <BeneficiaryListFiltersWrapper />
        <ResetFiltersWrapper />
      </div>
      <BeneficiaryList onSelectBeneficiary={onSelectBeneficiary}>
        {(table) => <CallToActions table={table} />}
      </BeneficiaryList>
      <BeneficiaryListPagination />
    </div>
  )
}

function CallToActions({ table }: { table: Table<BeneficiaryListDataItem> }) {
  const beneficiaries = useSelector(selectBeneficiaries)
  const disabled = beneficiaries.length === 0
  const columns = table.getAllColumns()
  const initialColumns = columns.map((column) => ({
    id: column.id,
    // @ts-expect-error we are sure meta and label exist here
    label: column.columnDef.meta.label as string,
    selected: column.getIsVisible(),
  }))
  const organizationId = useStoreState((state) => state.user.currentOrganizationId)
  if (!organizationId) return null
  return (
    <div className="absolute -top-32 right-0 z-10 flex items-center gap-2">
      <TasksCreator disabled={disabled} />
      <CsvExporter initialColumns={initialColumns} disabled={disabled} />
      <ColumnsSelector columns={columns} />
    </div>
  )
}
